import type { Role } from "../types"

const accessMap: Record<string, Role[]> = {
  "/": ["Admin"],
  "/clients": ["Admin", "Staff"],
  "/projects": ["Admin", "Staff"],
  "/time": ["Admin", "Staff", "Contractor"],
  "/billing": ["Admin"],
  "/reports": ["Admin"],
  "/tasks": ["Admin", "Staff", "Contractor"],
  "/users": ["Admin"],
  "/sales": ["Admin"],
  "/settings": ["Admin", "Staff", "Contractor"],
}

const normalizePath = (path: string): string => {
  if (path === "/") return "/"
  if (path.startsWith("/projects/")) return "/projects"
  if (path.startsWith("/users/")) return "/users"
  if (path.startsWith("/clients/")) return "/clients"
  if (path.startsWith("/tasks/")) return "/tasks"
  if (path.startsWith("/time/")) return "/time"
  if (path.startsWith("/billing/")) return "/billing"
  if (path.startsWith("/reports/")) return "/reports"
  if (path.startsWith("/sales/")) return "/sales"
  if (path.startsWith("/settings/")) return "/settings"
  return path
}

export const canAccessPath = (role: Role | null | undefined, path: string): boolean => {
  if (!role) return false
  const key = normalizePath(path)
  const allowed = accessMap[key]
  if (!allowed) return false
  return allowed.includes(role)
}

export const defaultPathForRole = (role: Role | null | undefined): string => {
  if (role === "Admin") return "/"
  if (role === "Staff" || role === "Contractor") return "/tasks"
  return "/login"
}

export const isRoleAllowedForPath = (roles: Role[], path: string): boolean => {
  const key = normalizePath(path)
  const allowed = accessMap[key]
  if (!allowed) return false
  return roles.some((role) => allowed.includes(role))
}
